module.exports = __webpack_public_path__ + "static/media/cancel.a56f4b8b.svg";